import { render, staticRenderFns } from "./BaseContentPage.vue?vue&type=template&id=ad21a2a2&"
import script from "./BaseContentPage.vue?vue&type=script&lang=ts&"
export * from "./BaseContentPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports